import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCollectionDetailsService,
  getCollectionNFTsService,
  searchCollectionNFTsService,
} from "../../apiService/collectionDetails";
interface CollectionNFTsPayload {
  collectionId: string | undefined;
  name: string;
  rank_by: string;
  limit?: number;
  page?: number;
}

interface SearchCollectionNFTsPayload {
  collectionId: string | undefined;
  keyword: string;
  limit: number;
  page: number;
}

export const getCollectionDetails = createAsyncThunk(
  "vyga/getCollectionDetails",
  async (collectionId: string | undefined, { rejectWithValue }) => {
    try {
      const result = await getCollectionDetailsService(collectionId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCollectionNFTs = createAsyncThunk(
  "vyga/getCollectionNFTs",
  async (
    { collectionId, limit, page, name, rank_by }: CollectionNFTsPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getCollectionNFTsService(
        collectionId,
        limit,
        page,
        name,
        rank_by
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const searchCollectionNFTs = createAsyncThunk(
  "vyga/getCollectionNFTs",
  async (
    { collectionId, keyword, limit, page }: SearchCollectionNFTsPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await searchCollectionNFTsService(
        collectionId,
        keyword,
        limit,
        page
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
